import {dateTimeToMoment} from '../tools/inits.js';
import {DATES_MOMENT_FORMAT} from '../tools/constants.js'

export const createAvailibilityDatesDict = (availabilityArr) => {

    let dic = {};
    if(availabilityArr==null) return dic;
    for (let value of availabilityArr){
        dic[dateTimeToMoment(value.date).format(DATES_MOMENT_FORMAT)] = {
            available: value.available,
            closedForArrival: value.closedForArrival,
            closedForDeparture: value.closedForDeparture,
            minLOS: value.minLOS,
            roomCategory: value.roomCategory,
            roomsAvailableForSale: value.roomsAvailableForSale
        }
    }

    return dic;
}


// WEBPACK FOOTER //
// ./src/utils/availablility.utils.js